import {
  FETCH_USER_APP_STATE_REQUEST,
  FETCH_USER_APP_STATE_SUCCESS,
  FETCH_USER_APP_STATE_FAILURE,
} from "../../actionTypes/userAppState";
import { RewardsService } from "../../../../api/RewardsService";
import { CognitoUser } from "amazon-cognito-identity-js";

interface FetchUserAppStateRequestAction {
  type: typeof FETCH_USER_APP_STATE_REQUEST;
}

interface FetchUserAppStateSuccessAction {
  type: typeof FETCH_USER_APP_STATE_SUCCESS;
  payload: any;
}

interface FetchUserAppStateFailureAction {
  type: typeof FETCH_USER_APP_STATE_FAILURE;
  payload: any;
}

export const fetchUserAppStateRequest = (): FetchUserAppStateRequestAction => ({
  type: FETCH_USER_APP_STATE_REQUEST,
});

export const fetchUserAppStateSuccess = (userAppState: string): FetchUserAppStateSuccessAction => ({
  type: FETCH_USER_APP_STATE_SUCCESS,
  payload: userAppState,
});

export const fetchUserAppStateFailure = (error: any): FetchUserAppStateFailureAction => ({
  type: FETCH_USER_APP_STATE_FAILURE,
  payload: error,
});

export type AppStateActions =
  | FetchUserAppStateRequestAction
  | FetchUserAppStateSuccessAction
  | FetchUserAppStateFailureAction;

// action to fetch user app state from the backend
export const fetchUserAppState = (
  dispatch: any,
  cognitoUser: CognitoUser,
  propertyId?: any,
  accountingId?: any
): any => {
  return async () => {
    const rewardsApiService = new RewardsService(cognitoUser, dispatch);
    dispatch(fetchUserAppStateRequest());
    try {
      const userAppStateResp = await rewardsApiService.getUserAppState(propertyId, accountingId);
      const userAppState = userAppStateResp.userAppState;
      dispatch(fetchUserAppStateSuccess(userAppState));
    } catch (error: any) {
      dispatch(fetchUserAppStateFailure(error.message));
    }
  };
};
